import Vue from "vue"
import { GetterTree, ActionTree, MutationTree } from "vuex"

import { RootState } from "~/store"
import TagType from "~/entities/tagType"
import Tag from "~/entities/tag"
import Influencer, {
  InfluencerLikedNeutralHatedTags,
  InfluencerTags,
} from "~/types/influencer"

export const state = () => ({
  selected_tag_ids: [] as number[],
  selected_influencer_ids: [] as number[],
  tag_stats: {} as Record<number, number>,
  parent_stats: {} as Record<number, number>,
  loading: false,
  search: "",
})
export type MiscSendtrackFiltersState = ReturnType<typeof state>

export const mutations: MutationTree<MiscSendtrackFiltersState> = {
  SET_SEARCH(state, str: string) {
    state.search = str
  },
  SET_SELECTED_TAG_IDS(state, idArray: number[]) {
    Vue.set(state, "selected_tag_ids", idArray)
  },
  SET_SELECTED_INFLUENCER_IDS(state, idArray: number[]) {
    Vue.set(state, "selected_influencer_ids", idArray)
  },
  SET_TAG_STATS(state, stats: Record<number, number>) {
    Vue.set(state, "tag_stats", stats)
  },
  SET_PARENT_STATS(state, stats: Record<number, number>) {
    Vue.set(state, "parent_stats", stats)
  },
  SET_LOADING(state, payload: boolean) {
    state.loading = Boolean(payload)
  },
}

export const actions: ActionTree<MiscSendtrackFiltersState, RootState> = {
  FETCH_STATS({ state, commit }): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Promise.all([
        Object.keys(state.tag_stats).length > 0
          ? state.tag_stats
          : this.$axios.$get("/influencer/tag_counts/"),
        Object.keys(state.parent_stats).length > 0
          ? state.parent_stats
          : this.$axios.$get("/influencer/parent_counts/"),
      ])
        .then(
          ([tag_stats, parent_stats]: [
            Record<number, number>,
            Record<number, number>
          ]) => {
            commit("SET_TAG_STATS", tag_stats)
            commit("SET_PARENT_STATS", parent_stats)
            resolve(true)
          }
        )
        .catch((err) => {
          reject(err)
        })
    })
  },
  FETCH({ dispatch }): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Promise.all([
        dispatch("FETCH_STATS"),
        dispatch("tag/FETCH", null, { root: true }),
      ])
        .then(() => resolve(true))
        .catch((err) => reject(err))
    })
  },
  EMPTY({ commit }): void {
    commit("SET_SELECTED_TAG_IDS", [])
  },
}

export const getters: GetterTree<MiscSendtrackFiltersState, RootState> = {
  NB_FILTER_SELECTED(state): number {
    return state.selected_tag_ids.length
  },
  SEND_DATA(state, _, rootState) {
    //@ts-ignore
    const tagTypes: TagType[] = rootState.tag.types

    return tagTypes.reduce((accumulator, tagType) => {
      const tag_id_array = state.selected_tag_ids.filter((selected_tag_id) =>
        tagType.tag_ids.includes(selected_tag_id)
      )

      if (tag_id_array.length) accumulator[tagType.name] = tag_id_array
      return accumulator
    }, {} as Record<string, number[]>)
  },
  FORMATTED_QUERY(_, getters) {
    const out = Object.keys(getters.SEND_DATA).reduce((accumulator, key) => {
      return accumulator + `${key}=${getters.SEND_DATA[key].join(",")}&`
    }, "?")

    return out.substr(0, out.length - 1)
  },
  SELECTED_INFLUENCER_IDS: (state, _, __, rootGetters) => {
    /* This is not optimal we NEED search in backend ASAP !*/
    /* hjalp */
    if (state.search.length) {
      const influencerSet: Influencer[] = rootGetters["influencers/GET_BY_IDS"](
        state.selected_influencer_ids.length
          ? state.selected_influencer_ids
          : rootGetters["influencers/IDS"]
      )
      const typeNames: ("mood" | "subgenre")[] = ["mood", "subgenre"]
      const searchRegExp = new RegExp(
        state.search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
        "gi"
      )
      const tagSearch = function (
        influencer: Influencer,
        target: "liked" | "hated" | "neutral" | "identity",
        typeNames: (
          | keyof InfluencerLikedNeutralHatedTags
          | "influencer_kind"
          | "country"
        )[]
      ): boolean {
        return typeNames.some((typeName) => {
          const influencerTags: Tag[] = rootGetters["tag/GET_TAGS_FROM_IDS"](
            //@ts-ignore
            influencer.tags[target][typeName] ?? []
          )

          return influencerTags.some((tag: Tag) => {
            return tag.name.toLowerCase().includes(state.search.toLowerCase())
          })
        })
      }

      return influencerSet.reduce(
        (accumulator: number[], influencer: Influencer) => {
          if (
            influencer.entity.match(searchRegExp) ||
            tagSearch(influencer, "liked", typeNames) ||
            tagSearch(influencer, "neutral", typeNames) ||
            tagSearch(influencer, "identity", ["influencer_kind", "country"])
          )
            accumulator.push(influencer.id)
          return accumulator
        },
        [] as number[]
      )
    } else return state.selected_influencer_ids
  },
}
